import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

type DragHandleProps = {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap | undefined;
  isDragging?: boolean;
};

export const DragHandle = ({ attributes, listeners, isDragging }: DragHandleProps) => {
  const style = {
    cursor: isDragging ? 'grabbing' : 'grab',
  };
  return (
    <div {...attributes} {...listeners} style={style}>
      <svg
        fill="#000000"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
      >
        <path d="M20,11H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h16c0.6,0,1-0.4,1-1S20.6,11,20,11z M4,8h16c0.6,0,1-0.4,1-1s-0.4-1-1-1H4C3.4,6,3,6.4,3,7S3.4,8,4,8z M20,16H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h16c0.6,0,1-0.4,1-1S20.6,16,20,16z" />
      </svg>
    </div>
  );
};
